import { fetchJson } from "../apiClient";
import { frontendEnv } from "../env";

type MediaTranslationNone = {
  kind: "none";
};

type MediaTranslationHtml = {
  kind: "html";
  html: string;
};

type MediaTranslationFile = {
  kind: "file";
  url: string;
  mimeType: string | null;
  filename: string | null;
};

type MediaTranslationFileInfo = {
  url: string;
  mimeType: string | null;
  filename: string | null;
};

type MediaTranslationMixed = {
  kind: "mixed";
  html: string;
  file: MediaTranslationFileInfo;
};

export type MediaTranslation = MediaTranslationNone | MediaTranslationHtml | MediaTranslationFile | MediaTranslationMixed;

export type MediaTranslationResponse = {
  assetId: string;
  translation: MediaTranslation;
};

export async function fetchMediaTranslation(assetId: string): Promise<MediaTranslationResponse> {
  const response = await fetchJson<MediaTranslationResponse>(
    `${frontendEnv.publicApiBaseUrl}/api/media/${encodeURIComponent(assetId)}/translation`,
  );

  if (response.translation.kind === "file") {
    const absoluteUrl = new URL(response.translation.url, frontendEnv.publicMediaBaseUrl).toString();
    return {
      ...response,
      translation: {
        ...response.translation,
        url: absoluteUrl,
      },
    };
  }

  if (response.translation.kind === "mixed") {
    const absoluteUrl = new URL(response.translation.file.url, frontendEnv.publicMediaBaseUrl).toString();
    return {
      ...response,
      translation: {
        ...response.translation,
        file: {
          ...response.translation.file,
          url: absoluteUrl,
        },
      },
    };
  }

  return response;
}
